import { ContactService } from './../../../services/contact.service';
import { Component, OnInit } from '@angular/core';
import { IContactForm, IError } from 'src/app/interfaces';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css'],
})
export class ContactComponent {
  constructor(
    public contactService: ContactService,
    private snackBar: MatSnackBar,
    private router: Router
  ) {}

  contactForm: IContactForm = {
    name: '',
    email: '',
    message: '',
    phone: '',
  };

  send(form: NgForm) {
    this.contactService.sendEmail(this.contactForm).subscribe(
      (data) => {
        this.snackBar.open('Mensagem enviada, em breve entraremos em contato!', 'Fechar', {
          duration: 7000,
        });
        this.contactForm = {
          name: '',
          email: '',
          message: '',
          phone: '',
        };
        form.resetForm();
      },
      (error: IError) => {
        this.snackBar.open('Mensagem não enviada, tente novamente mais tarde','Fechar', {
            duration: 7000,
          }
        );
      }
    );
  }
}
